import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'app-network-error-timeout',
    template: require('./network.error.timeout.component.html')
})

export class NetworkErrorTimeoutComponent {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                @Inject(MatDialogRef<NetworkErrorTimeoutComponent>) public dialogRef: MatDialogRef<NetworkErrorTimeoutComponent>) {
    }

    closeIt(value: any) {
        this.dialogRef.close(value)
    }

}
